import { useTheme } from "@mui/material/styles";

import MuiAppBar from "@mui/material/AppBar";
import MuiToolbar from "@mui/material/Toolbar";


AppBar.Toolbar = (props) => {
	const theme = useTheme();
	const style = {
		root: {
			justifyContent: "space-between",
			gap: { xs: 1.25, sm: 3.75 },
			p: theme.spacing(1, 2)
		}
	};

	return <MuiToolbar {...props} sx={{ ...style.root, ...props.sx }} />;
};

export default function AppBar(props) {
	return <MuiAppBar {...props} />;
}